import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LostPasswordService } from 'src/app/providers/lost-password.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { Password_request } from 'src/app/models/password_request';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/providers/user.service';

@Component({
  standalone: false,
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
styleUrls:  ['./update-password.component.css']
})
export class UpdatePasswordComponent extends SmsAbstractAppPage implements OnInit {

  password: any = "";
  repeat_password: any = "";
  user: User = new User();
  submitted: boolean = false;
  success: boolean = false;
  token: string;
  password_request: Password_request = new Password_request();

  constructor(private route: ActivatedRoute, private router: Router, private lostPasswordService: LostPasswordService, private userService: UserService) {

    super();

    this.route.params.subscribe(params => {

      if (params['token']) {
        this.token = params['token'];

        // Call the API to verify the token
        this.lostPasswordService.get(this.token).then((pr: Password_request) => {

          this.password_request = pr;

          this.userService.get(this.password_request.user_id).then((user: User) => {

            this.user = user;

          }).catch(error => {
            this.handleError(error);
          });


        }).catch(error => {
          this.handleError(error);
        });


      } else {
        this.handleError("Invalid token");
      }
    });

  }

  ngOnInit(): void {
  }

  handleSubmit() {

    let error_message: string = "";

    if (this.password != this.repeat_password) {
      error_message += "Passwords do not match";
    }

    if (this.password.length < 8) {
      error_message += "Password must be at least 8 characters";
    }

    let password_strength = this.checkPasswordStrength(this.password);

    if (password_strength < PasswordCheckStrength.Ok) {
      error_message += "Please make sure the password contains at least one uppercase letter, one lowercase letter, one number and one special character.";
    }

    if (error_message.length > 0) {
      this.handleError(error_message);
      return;
    }

    this.submitted = true;

    this.lostPasswordService.submitNewPassword(this.token, this.password, this.repeat_password).then(response => {
      this.success = response;
    }).catch(error => {
      this.handleError(error);
      this.submitted = false;
    });

  }

  public checkPasswordStrength(password: string): PasswordCheckStrength {

    // Build up the strenth of our password
    let numberOfElements = 0;
    numberOfElements = /.*[a-z].*/.test(password) ? ++numberOfElements : numberOfElements;      // Lowercase letters
    numberOfElements = /.*[A-Z].*/.test(password) ? ++numberOfElements : numberOfElements;      // Uppercase letters
    numberOfElements = /.*[0-9].*/.test(password) ? ++numberOfElements : numberOfElements;      // Numbers
    numberOfElements = /[^a-zA-Z0-9]/.test(password) ? ++numberOfElements : numberOfElements;   // Special characters (inc. space)

    // Assume we have a poor password already
    let currentPasswordStrength = PasswordCheckStrength.Short;

    // Check then strenth of this password using some simple rules
    if (password === null || password.length < 8) {
      currentPasswordStrength = PasswordCheckStrength.Short;
    } else if (numberOfElements === 0 || numberOfElements === 1 || numberOfElements === 2) {
      currentPasswordStrength = PasswordCheckStrength.Weak;
    } else if (numberOfElements === 3) {
      currentPasswordStrength = PasswordCheckStrength.Ok;
    } else {
      currentPasswordStrength = PasswordCheckStrength.Strong;
    }

    // Return the strength of this password
    return currentPasswordStrength;
  }

  handleLoginNavigate() {
    this.router.navigate(['/login']);
  }

}

export const enum PasswordCheckStrength {
  Short,
  Common,
  Weak,
  Ok,
  Strong,
};
